import { useCallback, useMemo, useState } from "react";
import { _ } from "@sablier/v2-mixins";
import { Stream } from "@sablier/v2-models";
import { vendors } from "@sablier/v2-utils";
import { useModalMomentPicker } from "~/client/hooks";

export function useSimulator(stream?: Stream) {
  const { setOpen } = useModalMomentPicker();

  const base = useMemo(() => {
    if (stream && !stream.isAlive) {
      return stream.endTime;
    }

    return Date.now().toString();
  }, [stream]);

  const [date, setDate] = useState<string | undefined>(base);

  const amount = useMemo(
    () =>
      !_.isNilOrEmptyString(stream) && !_.isNilOrEmptyString(date)
        ? stream.findStreamedAmount(date).humanized.toString()
        : undefined,
    [date, stream],
  );

  const onConfirm = useCallback((value?: string) => {
    setDate(value);
  }, []);

  const onClick = useCallback(() => {
    vendors.track.log((events) => {
      return events.openModalFrom({
        nameKey: "moment",
        placeKey: "streamSimulator",
      });
    });
    setOpen(true, {
      milliseconds: date || "",
      onConfirm,
    });
  }, [setOpen, date, onConfirm]);

  const placeholder = useMemo(
    () => _.toDuration(new Date().valueOf(), "date")[0],
    [],
  );

  return {
    date,
    amount,
    onClick,
    placeholder,
  };
}
